@let entity = incomeTaxEntity$ | async;
@let isPartner = partnerAangifte$ | async;
@if (entity) {
  <snelstart-ui-details
    [config]="detailsConfig"
    [entityId]="id"
    [showTitleBorder]="isIdExcluded(id) || (!isIdExcluded(id) && entity?.aangifte?.partnerAangifte === undefined)"
    [title]="jaarstukkenOpen ? getNaamOnderneming() + ' ' + year : id"
  >
    @if (!isIdExcluded(id) && entity?.aangifte?.partnerAangifte && !jaarstukkenOpen) {
      <snelstart-ui-details-header>
        <snelstart-ui-tab>
          <snelstart-ui-tab-item (click)="onSelectTab(false)"
                                 [isActive]="isPartner === false"
                                 id="firstTab">
            Aangever: {{ entity?.aangifte?.aangever?.voorletters }} {{ entity?.aangifte?.aangever?.tussenvoegsels || undefined }} {{ entity?.aangifte?.aangever?.achternaam }}
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item (click)="onSelectTab(true)"
                                 [isActive]="isPartner === true"
                                 id="secondTab">
            Partner: {{ entity?.aangifte?.partnerAangifte?.aangever?.voorletters }} {{ entity?.aangifte?.partnerAangifte?.aangever?.tussenvoegsels || undefined }} {{ entity?.aangifte?.partnerAangifte?.aangever?.achternaam }}
          </snelstart-ui-tab-item>
        </snelstart-ui-tab>
      </snelstart-ui-details-header>
    }

    <!--    Jaarstukken tabs-->
    @if (id === 'Ondernemingen' && jaarstukkenOpen) {
      <snelstart-ui-details-header>
        <snelstart-ui-tab>
          <snelstart-ui-tab-item (click)="onSelectOnderdeel('Vragen vooraf')"
                                 [isActive]="onderdeelVisible$.value === 'Vragen vooraf'"
                                 id="tab1">
            Vragen vooraf
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item (click)="onSelectOnderdeel('Administratie inlezen')"
                                 [isActive]="onderdeelVisible$.value === 'Administratie inlezen'"
                                 id="tab2">
            Administratie inlezen
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item (click)="onSelectOnderdeel('Resultatenrekening')"
                                 [isActive]="onderdeelVisible$.value === 'Resultatenrekening'"
                                 id="tab3">
            Resultatenrekening
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item (click)="onSelectOnderdeel('Balans activa')"
                                 [isActive]="onderdeelVisible$.value === 'Balans activa'"
                                 id="tab4">
            Balans activa
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item (click)="onSelectOnderdeel('Balans passiva')"
                                 [isActive]="onderdeelVisible$.value === 'Balans passiva'"
                                 id="tab5">
            Balans passiva
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item (click)="onSelectOnderdeel('Samenwerkingsverband')"
                                 [isActive]="onderdeelVisible$.value === 'Samenwerkingsverband'"
                                 id="tab6">
            Samenwerkingsverband
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item (click)="onSelectOnderdeel('Priveonttrekkingen en -stortingen')"
                                 [isActive]="onderdeelVisible$.value === 'Priveonttrekkingen en -stortingen'"
                                 id="tab7">
            Prive-opnamen
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item (click)="onSelectOnderdeel('Investeringen')"
                                 [isActive]="onderdeelVisible$.value === 'Investeringen'"
                                 id="tab9">
            Investeringen
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item (click)="onSelectOnderdeel('Winstcorrecties')"
                                 [isActive]="onderdeelVisible$.value === 'Winstcorrecties'"
                                 id="tab10">
            Winstcorrecties
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item (click)="onSelectOnderdeel('Vermogensvergelijking')"
                                 [isActive]="onderdeelVisible$.value === 'Vermogensvergelijking'"
                                 id="tab8">
            Vermogensvergelijking
          </snelstart-ui-tab-item>
        </snelstart-ui-tab>

        @if (onderdeelVisible$.value !== '') {
          <snelstart-ui-tab-content class="pt-3">
            @if (onderdeelVisible$.value === 'Vragen vooraf') {
              <snelstart-venture-fiscaal-feature-vragen-vooraf-ond></snelstart-venture-fiscaal-feature-vragen-vooraf-ond>
            }
            @if (onderdeelVisible$.value === 'Administratie inlezen') {
              <snelstart-venture-fiscaal-feature-administratie-koppelen-ib />
            }
            @if (onderdeelVisible$.value === 'Resultatenrekening') {
              <snelstart-venture-fiscaal-feature-winst-en-verlies></snelstart-venture-fiscaal-feature-winst-en-verlies>
            }
            @if (onderdeelVisible$.value === 'Balans activa') {
              <snelstart-venture-fiscaal-feature-balans-activa></snelstart-venture-fiscaal-feature-balans-activa>
            }
            @if (onderdeelVisible$.value === 'Balans passiva') {
              <snelstart-venture-fiscaal-feature-balans-passiva></snelstart-venture-fiscaal-feature-balans-passiva>
            }
            @if (onderdeelVisible$.value === 'Samenwerkingsverband') {
              <snelstart-venture-fiscaal-feature-samenwerkingsverband></snelstart-venture-fiscaal-feature-samenwerkingsverband>
            }
            @if (onderdeelVisible$.value === 'Priveonttrekkingen en -stortingen') {
              <snelstart-venture-fiscaal-feature-prive-ontrekkingen-en-stortingen></snelstart-venture-fiscaal-feature-prive-ontrekkingen-en-stortingen>
            }
            @if (onderdeelVisible$.value === 'Vermogensvergelijking') {
              <snelstart-venture-fiscaal-feature-vermogensvergelijking></snelstart-venture-fiscaal-feature-vermogensvergelijking>
            }
            @if (onderdeelVisible$.value === 'Investeringen') {
              <snelstart-venture-fiscaal-feature-investeringen></snelstart-venture-fiscaal-feature-investeringen>
            }
            @if (onderdeelVisible$.value === 'Winstcorrecties') {
              <snelstart-venture-fiscaal-feature-winstcorrecties></snelstart-venture-fiscaal-feature-winstcorrecties>
            }
          </snelstart-ui-tab-content>
        }
      </snelstart-ui-details-header>
    }

    <snelstart-ui-details-content>
      <!-- Persoonlijk-->

      @if (id === 'Aangever') {
        <snelstart-venture-fiscaal-feature-aangever></snelstart-venture-fiscaal-feature-aangever>
      }
      @if (id === 'Wijziging burgerlijke staat') {
        <snelstart-venture-fiscaal-feature-relatiegegevens></snelstart-venture-fiscaal-feature-relatiegegevens>
      }
      @if (id === 'Partner') {
        <snelstart-venture-fiscaal-feature-partner></snelstart-venture-fiscaal-feature-partner>
      }
      @if (id === 'Kinderen') {
        <snelstart-venture-fiscaal-feature-kind></snelstart-venture-fiscaal-feature-kind>
      }
      @if (id === 'Inlezen') {
        <snelstart-venture-fiscaal-feature-via></snelstart-venture-fiscaal-feature-via>
      }

      <!--Box 1 Winst uit onderneming-->

      @if (id === 'Ondernemingen' && !jaarstukkenOpen) {
        <snelstart-venture-fiscaal-feature-algemeen
          (openJaarstukken)="openJaarstukken($event)">
        </snelstart-venture-fiscaal-feature-algemeen>
      }
      @if (id === 'Ondernemersaftrek') {
        <snelstart-venture-fiscaal-feature-ondernemer></snelstart-venture-fiscaal-feature-ondernemer>
      }
      @if (id === 'Samenvatting winst') {
        <snelstart-venture-fiscaal-feature-box1-winst-uit-onderneming></snelstart-venture-fiscaal-feature-box1-winst-uit-onderneming>
      }

      <!--Box 1 loon-->

      @if (id === 'Inkomsten uit loondienst') {
        <snelstart-venture-fiscaal-feature-loon-tegenwoordig></snelstart-venture-fiscaal-feature-loon-tegenwoordig>
      }
      @if (id === 'Pensioen en andere uitkeringen') {
        <snelstart-venture-fiscaal-feature-loon-vroeger></snelstart-venture-fiscaal-feature-loon-vroeger>
      }
      @if (id === 'Buitenlands loon') {
        <snelstart-venture-fiscaal-feature-loon-buitenland></snelstart-venture-fiscaal-feature-loon-buitenland>
      }
      @if (id === 'Vrijgesteld loon') {
        <snelstart-venture-fiscaal-feature-loon-internationale-organisatie></snelstart-venture-fiscaal-feature-loon-internationale-organisatie>
      }
      @if (id === 'Meer banen of uitkeringen tegelijk') {
        <snelstart-venture-fiscaal-feature-meer-banen-tegelijk></snelstart-venture-fiscaal-feature-meer-banen-tegelijk>
      }
      @if (id === 'Reiskosten openbaar vervoer') {
        <snelstart-venture-fiscaal-feature-reisaftrek-ov></snelstart-venture-fiscaal-feature-reisaftrek-ov>
      }
      @if (id === 'Samenvatting loon') {
        <snelstart-venture-fiscaal-feature-box1-belastbaar-loon></snelstart-venture-fiscaal-feature-box1-belastbaar-loon>
      }

      <!--Box 1 row-->

      @if (id === 'Resultaat uit overige werkzaamheden') {
        <snelstart-venture-fiscaal-feature-resultaat-uit-overige-werkzaamheden></snelstart-venture-fiscaal-feature-resultaat-uit-overige-werkzaamheden>
      }
      @if (id === 'Terbeschikkingstellingsregeling') {
        <snelstart-venture-fiscaal-feature-tbs-regeling></snelstart-venture-fiscaal-feature-tbs-regeling>
      }

      <!--Box 1 belastbare periodieke uitkeringen en verstrekkingen-->

      @if (id === 'Alimentatie') {
        <snelstart-venture-fiscaal-feature-alimentatie></snelstart-venture-fiscaal-feature-alimentatie>
      }
      @if (id === 'Periodieke uitkeringen') {
        <snelstart-venture-fiscaal-feature-periodieke-uitkeringen></snelstart-venture-fiscaal-feature-periodieke-uitkeringen>
      }
      @if (id === 'Samenvatting overige inkomsten') {
        <snelstart-venture-fiscaal-feature-box1-resultaat-overige-werkzaamheden></snelstart-venture-fiscaal-feature-box1-resultaat-overige-werkzaamheden>
      }

      <!--Box 1 belastbare inkomsten op basis van overgangsrecht-->

      @if (id === 'Inkomsten overgangsrecht') {
        <snelstart-venture-fiscaal-feature-box1-belastbare-inkomsten-op-basis-van-overgangsrecht></snelstart-venture-fiscaal-feature-box1-belastbare-inkomsten-op-basis-van-overgangsrecht>
      }

      <!--Box 1 belastbare inkomsten uit eigen woning-->

      @if (id === 'Woningen') {
        <snelstart-venture-fiscaal-feature-eigenwoningen></snelstart-venture-fiscaal-feature-eigenwoningen>
      }
      @if (id === 'Eigenwoningschulden') {
        <snelstart-venture-fiscaal-feature-eigenwoning-schulden></snelstart-venture-fiscaal-feature-eigenwoning-schulden>
      }
      @if (id === 'Financieringskosten') {
        <snelstart-venture-fiscaal-feature-financieringskosten></snelstart-venture-fiscaal-feature-financieringskosten>
      }
      @if (id === 'Restschulden') {
        <snelstart-venture-fiscaal-feature-eigenwoning-restschulden></snelstart-venture-fiscaal-feature-eigenwoning-restschulden>
      }
      @if (id === 'Huurinkomsten') {
        <snelstart-venture-fiscaal-feature-huurinkomsten></snelstart-venture-fiscaal-feature-huurinkomsten>
      }
      @if (id === 'Overig eigen woning') {
        <snelstart-venture-fiscaal-feature-overig-eigen-woning></snelstart-venture-fiscaal-feature-overig-eigen-woning>
      }
      @if (id === 'Samenvatting eigen woning') {
        <snelstart-venture-fiscaal-feature-box1-belastbare-inkomsten-uit-eigenwoning></snelstart-venture-fiscaal-feature-box1-belastbare-inkomsten-uit-eigenwoning>
      }

      <!--Box 1 uitgaven voor inkomensvoorzieningen-->

      @if (id === 'Premies lijfrente') {
        <snelstart-venture-fiscaal-feature-lijfrente-premies></snelstart-venture-fiscaal-feature-lijfrente-premies>
      }
      @if (id === 'Jaar- en reserveringsruimte') {
        <snelstart-venture-fiscaal-feature-jaarruimtegegevens></snelstart-venture-fiscaal-feature-jaarruimtegegevens>
      }
      @if (id === 'Overige premies inkomensvoorzieningen') {
        <snelstart-venture-fiscaal-feature-overige-premies></snelstart-venture-fiscaal-feature-overige-premies>
      }
      @if (id === 'Samenvatting premies inkomensvoorzieningen') {
        <snelstart-venture-fiscaal-feature-box1-uitgaven-voor-inkomensvoorzieningen></snelstart-venture-fiscaal-feature-box1-uitgaven-voor-inkomensvoorzieningen>
      }

      <!--Box 1 negatieve premies  -->

      @if (id === 'Teruggave premies inkomensvoorzieningen') {
        <snelstart-venture-fiscaal-feature-box1-negatieve-uitgaven-voor-inkomensvoorzieningen></snelstart-venture-fiscaal-feature-box1-negatieve-uitgaven-voor-inkomensvoorzieningen>
      }

      <!--Box2-->

      @if (id === 'Aanmerkelijk belang (box 2)') {
        <snelstart-venture-fiscaal-feature-box2-inkomen-uit-aanmerkelijk-belang></snelstart-venture-fiscaal-feature-box2-inkomen-uit-aanmerkelijk-belang>
      }
      @if (id === 'Samenvatting aanmerkelijk belang') {
        <snelstart-venture-fiscaal-feature-box2-inkomen-uit-ab></snelstart-venture-fiscaal-feature-box2-inkomen-uit-ab>
      }

      <!--Box 3-->

      @if (id === 'Werkelijk rendement') {
        <snelstart-venture-fiscaal-feature-box3-owr></snelstart-venture-fiscaal-feature-box3-owr>
      }
      @if (id === 'Bankrekeningen') {
        <snelstart-venture-fiscaal-feature-box3-bankrekeningen></snelstart-venture-fiscaal-feature-box3-bankrekeningen>
      }
      @if (id === 'Beleggingen') {
        <snelstart-venture-fiscaal-feature-box3-beleggingsrekeningen></snelstart-venture-fiscaal-feature-box3-beleggingsrekeningen>
      }
      @if (id === 'Overige onroerende zaken') {
        <snelstart-venture-fiscaal-feature-box3-overige-onroerende-zaken></snelstart-venture-fiscaal-feature-box3-overige-onroerende-zaken>
      }
      @if (id === 'Overige bezittingen') {
        <snelstart-venture-fiscaal-feature-box3-overige-bezittingen></snelstart-venture-fiscaal-feature-box3-overige-bezittingen>
      }
      @if (id === 'Schulden') {
        <snelstart-venture-fiscaal-feature-box3-leningen></snelstart-venture-fiscaal-feature-box3-leningen>
      }
      @if (id === 'Samenvatting box 3') {
        <snelstart-venture-fiscaal-feature-box3></snelstart-venture-fiscaal-feature-box3>
      }

      <!--        PGA-->

      @if (id === 'Specifieke zorgkosten') {
        <snelstart-venture-fiscaal-feature-pga-specifieke-zorgkosten></snelstart-venture-fiscaal-feature-pga-specifieke-zorgkosten>
      }
      @if (id === 'Giften') {
        <snelstart-venture-fiscaal-feature-pga-aftrekbare-giften></snelstart-venture-fiscaal-feature-pga-aftrekbare-giften>
      }
      @if (id === 'Scholingsuitgaven') {
        <snelstart-venture-fiscaal-feature-studiefinanciering-aangever></snelstart-venture-fiscaal-feature-studiefinanciering-aangever>
      }
      @if (id === 'Onderhoudsverplichtingen') {
        <snelstart-venture-fiscaal-feature-pga-onderhoudsverplichtingen></snelstart-venture-fiscaal-feature-pga-onderhoudsverplichtingen>
      }
      @if (id === 'Weekenduitgaven gehandicapte kinderen') {
        <snelstart-venture-fiscaal-feature-pga-weekenduitgaven-gehandicapte-kinderen></snelstart-venture-fiscaal-feature-pga-weekenduitgaven-gehandicapte-kinderen>
      }
      @if (id === 'Restant persoonsgebonden aftrek voorgaande jaren') {
        <snelstart-venture-fiscaal-feature-pga-restant-pga-voorgaande-jaren></snelstart-venture-fiscaal-feature-pga-restant-pga-voorgaande-jaren>
      }
      @if (id === 'Negatieve persoonsgebonden aftrek') {
        <snelstart-venture-fiscaal-feature-box1-negatieve-persoonsgebonden-aftrek></snelstart-venture-fiscaal-feature-box1-negatieve-persoonsgebonden-aftrek>
      }
      @if (id === 'Samenvatting persoonsgebonden aftrek') {
        <snelstart-venture-fiscaal-feature-pga-samenvatting></snelstart-venture-fiscaal-feature-pga-samenvatting>
      }

      <!--    Verdeling-->
      @if (id === 'Verdeling') {
        <snelstart-venture-fiscaal-feature-verdeling></snelstart-venture-fiscaal-feature-verdeling>
      }

      <!--    Voorheffingen-->
      @if (id === 'Voorlopige aanslagen') {
        <snelstart-venture-fiscaal-feature-voorlopige-aanslagen></snelstart-venture-fiscaal-feature-voorlopige-aanslagen>
      }
      @if (id === 'Nederlandse dividendbelasting') {
        <snelstart-venture-fiscaal-feature-dividendbelasting></snelstart-venture-fiscaal-feature-dividendbelasting>
      }
      @if (id === 'Buitenlandse bronbelasting') {
        <snelstart-venture-fiscaal-feature-buitenlandse-bronheffing></snelstart-venture-fiscaal-feature-buitenlandse-bronheffing>
      }

      @if (id === 'Loon als onderdeel van winst') {
        <snelstart-venture-fiscaal-feature-loon-onderdeel-winst></snelstart-venture-fiscaal-feature-loon-onderdeel-winst>
      }

      <!--    Aanvullende vragen-->

      @if (id === 'Nog verrekenbaar') {
        <snelstart-venture-fiscaal-feature-verrekenbare-verliezen></snelstart-venture-fiscaal-feature-verrekenbare-verliezen>
      }

      <!--    Overzicht & Berekeningen-->

      @if (id === 'Overzicht inkomen box 1') {
        <snelstart-venture-fiscaal-feature-overzicht-inkomen-box1></snelstart-venture-fiscaal-feature-overzicht-inkomen-box1>
      }
      @if (id === 'Overzicht inkomen box 2') {
        <snelstart-venture-fiscaal-feature-overzicht-inkomen-box2></snelstart-venture-fiscaal-feature-overzicht-inkomen-box2>
      }
      @if (id === 'Overzicht inkomen box 3') {
        <snelstart-venture-fiscaal-feature-overzicht-inkomen-box3></snelstart-venture-fiscaal-feature-overzicht-inkomen-box3>
      }
      @if (id === 'Berekening inkomstenbelasting') {
        <snelstart-venture-fiscaal-feature-ib-overzicht></snelstart-venture-fiscaal-feature-ib-overzicht>
      }
      @if (id === 'Berekening zorgverzekeringswet') {
        <snelstart-venture-fiscaal-feature-zorgverzekeringswet></snelstart-venture-fiscaal-feature-zorgverzekeringswet>
      }

      @if (id === 'Premieplicht') {
        <snelstart-venture-fiscaal-feature-premieplicht></snelstart-venture-fiscaal-feature-premieplicht>
      }

      @if (id === 'Wereldinkomen') {
        <snelstart-venture-fiscaal-feature-opgaaf-wereldinkomen></snelstart-venture-fiscaal-feature-opgaaf-wereldinkomen>
      }

      @if (id === 'Conserverend inkomen') {
        <snelstart-venture-fiscaal-feature-conserverend-inkomen></snelstart-venture-fiscaal-feature-conserverend-inkomen>
      }

      <!--         APV Lijst-->

      @if (id === 'APV') {
        <snelstart-venture-fiscaal-feature-apv-lijst></snelstart-venture-fiscaal-feature-apv-lijst>
      }
    </snelstart-ui-details-content>

    <snelstart-ui-details-buttons>
      @if (jaarstukkenOpen) {
        <snelstart-ui-button (click)="jaarstukkenOpen=false"
                             class="me-1"
                             icon="circle-arrow-left"
                             type="link">
          Terug naar ondernemingen
        </snelstart-ui-button>
      }
      @if (showButtonOpslaan(id)) {
        <snelstart-ui-button [config]="config" class="me-2" type="primary">
          Opslaan
        </snelstart-ui-button>
      }
      @if (showButtonOpslaan(id)) {
        <snelstart-ui-button (click)="this.showDialogInfo()"
                             type="secondary">
          Toelichting
        </snelstart-ui-button>
      }
    </snelstart-ui-details-buttons>

    <snelstart-ui-dialog-definition [(visible)]="dialogInfoVisible" id="toelIB"
                                    size="lg"
                                    title="Toelichting bij '{{id}}'">
      <snelstart-ui-dialog-body>
        @if (this.id === 'Aangever') {
          <snelstart-venture-fiscaal-feature-tekst-persoonlijk-aangever></snelstart-venture-fiscaal-feature-tekst-persoonlijk-aangever>
        }
        @if (this.id === 'Wijziging burgerlijke staat') {
          <snelstart-venture-fiscaal-feature-tekst-persoonlijk-wijzigingBurgerlijkeStaat></snelstart-venture-fiscaal-feature-tekst-persoonlijk-wijzigingBurgerlijkeStaat>
        }
        @if (this.id === 'Partner') {
          <snelstart-venture-fiscaal-feature-tekst-persoonlijk-partner></snelstart-venture-fiscaal-feature-tekst-persoonlijk-partner>
        }
        @if (this.id === 'Kinderen') {
          <snelstart-venture-fiscaal-feature-tekst-persoonlijk-kinderen></snelstart-venture-fiscaal-feature-tekst-persoonlijk-kinderen>
        }

        @if (this.id === 'Onderneming') {
          <snelstart-venture-fiscaal-feature-tekst-wuo-onderneming></snelstart-venture-fiscaal-feature-tekst-wuo-onderneming>
        }
        @if (onderdeelVisible$.value === 'Vragen vooraf') {
          <snelstart-venture-fiscaal-feature-tekst-wuo-vragenVooraf></snelstart-venture-fiscaal-feature-tekst-wuo-vragenVooraf>
        }
        @if (onderdeelVisible$.value === 'Administratie inlezen') {
          <snelstart-venture-fiscaal-feature-tekst-wuo-adminKoppelen></snelstart-venture-fiscaal-feature-tekst-wuo-adminKoppelen>
        }
        @if (onderdeelVisible$.value === 'Resultatenrekening') {
          <snelstart-venture-fiscaal-feature-tekst-wuo-resultatenrekening></snelstart-venture-fiscaal-feature-tekst-wuo-resultatenrekening>
        }
        @if (onderdeelVisible$.value === 'Balans activa') {
          <snelstart-venture-fiscaal-feature-tekst-wuo-balansActiva></snelstart-venture-fiscaal-feature-tekst-wuo-balansActiva>
        }
        @if (onderdeelVisible$.value === 'Balans passiva') {
          <snelstart-venture-fiscaal-feature-tekst-wuo-balansPassiva></snelstart-venture-fiscaal-feature-tekst-wuo-balansPassiva>
        }
        @if (onderdeelVisible$.value === 'Samenwerkingsverband') {
          <snelstart-venture-fiscaal-feature-samenwerkingsverband></snelstart-venture-fiscaal-feature-samenwerkingsverband>
        }
        @if (onderdeelVisible$.value === 'Priveonttrekkingen en -stortingen') {
          <snelstart-venture-fiscaal-feature-tekst-wuo-prive></snelstart-venture-fiscaal-feature-tekst-wuo-prive>
        }
        @if (onderdeelVisible$.value === 'Vermogensvergelijking') {
          <snelstart-venture-fiscaal-feature-tekst-wuo-vermogensVergelijking></snelstart-venture-fiscaal-feature-tekst-wuo-vermogensVergelijking>
        }
        @if (onderdeelVisible$.value === 'Investeringen') {
          <snelstart-venture-fiscaal-feature-tekst-wuo-investeringen></snelstart-venture-fiscaal-feature-tekst-wuo-investeringen>
        }
        @if (onderdeelVisible$.value === 'Winstcorrecties') {
          <snelstart-venture-fiscaal-feature-tekst-wuo-winstcorrecties></snelstart-venture-fiscaal-feature-tekst-wuo-winstcorrecties>
        }
        @if (this.id === 'Ondernemersaftrek') {
          <snelstart-venture-fiscaal-feature-tekst-oa-ondernemersaftrek></snelstart-venture-fiscaal-feature-tekst-oa-ondernemersaftrek>
        }

        @if (this.id === 'Inkomsten uit loondienst') {
          <snelstart-venture-fiscaal-feature-tekst-loon-loondienst></snelstart-venture-fiscaal-feature-tekst-loon-loondienst>
        }
        @if (this.id === 'Reiskosten openbaar vervoer') {
          <snelstart-venture-fiscaal-feature-tekst-loon-reiskostenOv></snelstart-venture-fiscaal-feature-tekst-loon-reiskostenOv>
        }
        @if (this.id === 'Pensioen en andere uitkeringen') {
          <snelstart-venture-fiscaal-feature-tekst-loon-pensioen></snelstart-venture-fiscaal-feature-tekst-loon-pensioen>
        }
        @if (this.id === 'Buitenlands loon') {
          <snelstart-venture-fiscaal-feature-tekst-loon-buitenland></snelstart-venture-fiscaal-feature-tekst-loon-buitenland>
        }
        @if (this.id === 'Vrijgesteld loon') {
          <snelstart-venture-fiscaal-feature-tekst-loon-vrijgesteld></snelstart-venture-fiscaal-feature-tekst-loon-vrijgesteld>
        }
        @if (this.id === 'Meer banen of uitkeringen tegelijk') {
          <snelstart-venture-fiscaal-feature-tekst-loon-meerBanen></snelstart-venture-fiscaal-feature-tekst-loon-meerBanen>
        }

        @if (this.id === 'Resultaat uit overige werkzaamheden') {
          <snelstart-venture-fiscaal-feature-tekst-overigInkomen-row></snelstart-venture-fiscaal-feature-tekst-overigInkomen-row>
        }
        @if (this.id === 'Terbeschikkingstellingsregeling') {
          <snelstart-venture-fiscaal-feature-tekst-overigInkomen-tbs></snelstart-venture-fiscaal-feature-tekst-overigInkomen-tbs>
        }
        @if (this.id === 'Alimentatie') {
          <snelstart-venture-fiscaal-feature-tekst-overigInkomen-alimentatie></snelstart-venture-fiscaal-feature-tekst-overigInkomen-alimentatie>
        }
        @if (this.id === 'Periodieke uitkeringen') {
          <snelstart-venture-fiscaal-feature-tekst-overigInkomen-pu></snelstart-venture-fiscaal-feature-tekst-overigInkomen-pu>
        }

        @if (this.id === 'Woningen') {
          <snelstart-venture-fiscaal-feature-tekst-woning-woningen></snelstart-venture-fiscaal-feature-tekst-woning-woningen>
        }
        @if (this.id === 'Eigenwoningschulden') {
          <snelstart-venture-fiscaal-feature-tekst-woning-ews></snelstart-venture-fiscaal-feature-tekst-woning-ews>
        }
        @if (this.id === 'Financieringskosten') {
          <snelstart-venture-fiscaal-feature-tekst-woning-financieringskosten></snelstart-venture-fiscaal-feature-tekst-woning-financieringskosten>
        }
        @if (this.id === 'Restschulden') {
          <snelstart-venture-fiscaal-feature-tekst-woning-restschulden></snelstart-venture-fiscaal-feature-tekst-woning-restschulden>
        }
        @if (this.id === 'Huurinkomsten') {
          <snelstart-venture-fiscaal-feature-tekst-woning-huurinkomsten></snelstart-venture-fiscaal-feature-tekst-woning-huurinkomsten>
        }
        @if (this.id === 'Overig eigen woning') {
          <snelstart-venture-fiscaal-feature-tekst-woning-overig></snelstart-venture-fiscaal-feature-tekst-woning-overig>
        }

        @if (this.id === 'Premies lijfrente') {
          <snelstart-venture-fiscaal-feature-tekst-premies-lijfrente></snelstart-venture-fiscaal-feature-tekst-premies-lijfrente>
        }
        @if (this.id === 'Jaar- en reserveringsruimte') {
          <snelstart-venture-fiscaal-feature-tekst-premies-jaarruimte></snelstart-venture-fiscaal-feature-tekst-premies-jaarruimte>
        }
        @if (this.id === 'Overige premies inkomensvoorzieningen') {
          <snelstart-venture-fiscaal-feature-tekst-premies-overig></snelstart-venture-fiscaal-feature-tekst-premies-overig>
        }
        @if (this.id === 'Teruggave premies inkomensvoorzieningen') {
          <snelstart-venture-fiscaal-feature-tekst-premies-teruggave></snelstart-venture-fiscaal-feature-tekst-premies-teruggave>
        }

        @if (this.id === 'Aanmerkelijk belang (box 2)') {
          <snelstart-venture-fiscaal-feature-tekst-ab-inkomen></snelstart-venture-fiscaal-feature-tekst-ab-inkomen>
        }

        @if (this.id === 'Werkelijk rendement') {
          <snelstart-venture-fiscaal-feature-tekst-box3-werkelijkRendement></snelstart-venture-fiscaal-feature-tekst-box3-werkelijkRendement>
        }
        @if (this.id === 'Bankrekeningen') {
          <snelstart-venture-fiscaal-feature-tekst-box3-bank></snelstart-venture-fiscaal-feature-tekst-box3-bank>
        }
        @if (this.id === 'Beleggingen') {
          <snelstart-venture-fiscaal-feature-tekst-box3-beleggingen></snelstart-venture-fiscaal-feature-tekst-box3-beleggingen>
        }
        @if (this.id === 'Overige onroerende zaken') {
          <snelstart-venture-fiscaal-feature-tekst-box3-onrZaken></snelstart-venture-fiscaal-feature-tekst-box3-onrZaken>
        }
        @if (this.id === 'Overige bezittingen') {
          <snelstart-venture-fiscaal-feature-tekst-box3-overig></snelstart-venture-fiscaal-feature-tekst-box3-overig>
        }
        @if (this.id === 'Schulden') {
          <snelstart-venture-fiscaal-feature-tekst-box3-schulden></snelstart-venture-fiscaal-feature-tekst-box3-schulden>
        }

        @if (this.id === 'Specifieke zorgkosten') {
          <snelstart-venture-fiscaal-feature-tekst-pga-zorg></snelstart-venture-fiscaal-feature-tekst-pga-zorg>
        }
        @if (this.id === 'Giften') {
          <snelstart-venture-fiscaal-feature-tekst-pga-giften></snelstart-venture-fiscaal-feature-tekst-pga-giften>
        }
        @if (this.id === 'Scholingsuitgaven') {
          <snelstart-venture-fiscaal-feature-tekst-pga-scholing></snelstart-venture-fiscaal-feature-tekst-pga-scholing>
        }
        @if (this.id === 'Onderhoudsverplichtingen') {
          <snelstart-venture-fiscaal-feature-tekst-pga-onderhoud></snelstart-venture-fiscaal-feature-tekst-pga-onderhoud>
        }
        @if (this.id === 'Weekenduitgaven gehandicapte kinderen') {
          <snelstart-venture-fiscaal-feature-tekst-pga-weekend></snelstart-venture-fiscaal-feature-tekst-pga-weekend>
        }
        @if (this.id === 'Restant persoonsgebonden aftrek voorgaande jaren') {
          <snelstart-venture-fiscaal-feature-tekst-pga-restant></snelstart-venture-fiscaal-feature-tekst-pga-restant>
        }
        @if (this.id === 'Negatieve persoonsgebonden aftrek') {
          <snelstart-venture-fiscaal-feature-tekst-pga-negatief></snelstart-venture-fiscaal-feature-tekst-pga-negatief>
        }

        @if (this.id === 'Premieplicht') {
          <snelstart-venture-fiscaal-feature-tekst-premievrijstelling></snelstart-venture-fiscaal-feature-tekst-premievrijstelling>
        }
        @if (this.id === 'Wereldinkomen') {
          <snelstart-venture-fiscaal-feature-tekst-wereldinkomen></snelstart-venture-fiscaal-feature-tekst-wereldinkomen>
        }

        @if (this.id === 'Voorlopige aanslagen') {
          <snelstart-venture-fiscaal-feature-tekst-voorheffingen-va></snelstart-venture-fiscaal-feature-tekst-voorheffingen-va>
        }
        @if (this.id === 'Nederlandse dividendbelasting') {
          <snelstart-venture-fiscaal-feature-tekst-voorheffingen-divBel></snelstart-venture-fiscaal-feature-tekst-voorheffingen-divBel>
        }
        @if (this.id === 'Buitenlandse bronbelasting') {
          <snelstart-venture-fiscaal-feature-tekst-voorheffingen-buitenlBronbel></snelstart-venture-fiscaal-feature-tekst-voorheffingen-buitenlBronbel>
        }
        @if (this.id === 'Loon als onderdeel van winst') {
          <snelstart-venture-fiscaal-feature-tekst-voorheffingen-loonWinst></snelstart-venture-fiscaal-feature-tekst-voorheffingen-loonWinst>
        }

        @if (this.id === 'Nog verrekenbaar') {
          <snelstart-venture-fiscaal-feature-tekst-verrVerlies></snelstart-venture-fiscaal-feature-tekst-verrVerlies>
        }

        @if (this.id === 'Verdeling') {
          <snelstart-venture-fiscaal-feature-tekst-verdeling></snelstart-venture-fiscaal-feature-tekst-verdeling>
        }

        @if (this.id === 'Berekening inkomstenbelasting') {
          <snelstart-venture-fiscaal-feature-tekst-berekening-belasting></snelstart-venture-fiscaal-feature-tekst-berekening-belasting>
        }

        @if (this.id === 'Berekening zorgverzekeringswet') {
          <snelstart-venture-fiscaal-feature-tekst-berekening-premieZvw></snelstart-venture-fiscaal-feature-tekst-berekening-premieZvw>
        }

        <!-- algemene informatie van Belastingdienst-->
        <div class="accordion" id="accordionExample">

          <div class="accordion-item">
            <h2 class="accordion-header" id="headingMeer">
              <button aria-controls="collapseMeer" aria-expanded="false"
                      class="accordion-button collapsed"
                      data-bs-target="#collapseMeer" data-bs-toggle="collapse" type="button">
                Meer fiscale informatie
              </button>
            </h2>
            <div aria-labelledby="headingMeer" class="accordion-collapse collapse"
                 data-bs-parent="#accordionExample"
                 id="collapseMeer">
              <div class="accordion-body">
                De Belastingdienst stelt elk jaar bij de aangifte inkomstenbelasting online uitgebreide
                informatie over de belastingregels beschikbaar.

                <div class="space20"></div>

                <snelstart-ui-button iconRight="arrow-up-right-from-square" size="small" type="secondary">
                  <a [href]="belastingdienstFisinUrl" target="_blank">
                    Fiscale informatie inkomstenbelasting {{ this.year }}
                  </a>
                </snelstart-ui-button>
              </div>
            </div>
          </div>
        </div>

        <!--nog niet in aangifteprogramma-->
        <div class="accordion" id="accordionIB">

          <div class="accordion-item">
            <h2 class="accordion-header" id="headingIBr">
              <button aria-controls="collapseIB" aria-expanded="false" class="accordion-button collapsed"
                      data-bs-target="#collapseIB" data-bs-toggle="collapse" type="button">
                (Niet) Beschikbare onderdelen in aangifte inkomstenbelasting
              </button>
            </h2>
            <div aria-labelledby="headingIB" class="accordion-collapse collapse"
                 data-bs-parent="#accordionExample"
                 id="collapseIB">
              <div class="accordion-body">
                SnelStart Fiscaal groeit stapsgewijs in functionaliteiten. Het doel is het dé oplossing
                voor
                alle soorten belastingaangiften, inclusief beheer van uitstel en het machtigingsregister.
                <div class="space20"></div>
                <b>Wat zit er nog niet in de aangifte inkomstenbelasting?</b><br />
                De module voor de aangifte inkomstenbelasting voorziet momenteel nog niet in de volgende
                onderdelen:<br />
                <ul>
                  <li>Afzonderlijk aangifte invullen bij fiscaal partners</li>
                  <li>Winst uit onderneming voor agrarische ondernemingen</li>
                  <li>M-biljetten</li>
                  <li>Aangifte met een A.P.V. (Afgezonderd Particulier Vermogen)</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </snelstart-ui-dialog-body>

      <snelstart-ui-dialog-buttons class="d-flex mt-2">
        <snelstart-ui-button btn-x icon="check" id="sluiten" type="primary">Afsluiten
        </snelstart-ui-button>
      </snelstart-ui-dialog-buttons>
    </snelstart-ui-dialog-definition>
  </snelstart-ui-details>
}
